import React from 'react';
import MediaQuery from 'react-responsive';

import './Values.css';

function ValuesSection() {
  return (
    <div id="values">
      <MediaQuery query="(min-width: 425px)">
        <div className="half" />
      </MediaQuery>

      <div className="half" id="right">
        <div id="value">
          <h1>
          Inovação
            <span>.</span>
          </h1>
          <div className="halfUnderline" />
          <p>
          Pesquisa aplicada em soluções
            <br />
            desenvolvidas com parceiros entre
            <br />
            o mercadoe e a academia.
          </p>
        </div>

        <div id="value">
          <h1>
            Tecnologia
            <span>.</span>
          </h1>
          <div className="halfUnderline" />
          <p>
            Baseadas em pesquisa de tecnologia de ponta
            <br />
            relacionadas à vizualização, rastreio
            <br />
            e interação natural.
          </p>
        </div>

        <div id="value">
          <h1>
            Multidisciplinaridade
            <span>.</span>
          </h1>
          <div className="halfUnderline" />
          <p>
            Time multidiscipliar explorando
            <br />
            aplicações de tecnologias inovadoras
            <br />
            em diversos setores do mercado.
          </p>
        </div>
      </div>

    </div>
  );
}

export default ValuesSection;
